// import {auth} from "./auth";
import { useLocation } from "react-router-dom";
import { Navigate } from "react-router-dom";
import { toast } from "react-toastify";

export default function RequireAuth({ children }) {
  var isAuthenticated;
  if (localStorage.getItem("state")) {
    isAuthenticated = true;
  } else {
    isAuthenticated = false;
    toast.error("Unauthorized user",{autoClose:2000})
  }
  const location = useLocation();
  return isAuthenticated === true ? (
    children
  ) : (
    <Navigate to="/login" replace state={{ path: location.pathname }} />
  );
}
